var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "560E52F6-5BA2-43EE-96FE-16CF1F2A9A12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VIP-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Typography",
    transform: "translate(-475.000000, -4221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-icon",
    transform: "translate(475.000000, 4221.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3285C2",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3479983,8.85679729 L21.0437507,17.9700011 C21.336461,18.4383376 21.1940878,19.055288 20.7257513,19.3479983 C20.5668197,19.4473306 20.3831721,19.5 20.1957524,19.5 L8.80424764,19.5 C8.25196289,19.5 7.80424764,19.0522847 7.80424764,18.5 C7.80424764,18.3125803 7.85691709,18.1289327 7.95624934,17.9700011 L13.6520017,8.85679729 C13.944712,8.38846076 14.5616624,8.24608759 15.0299989,8.53879792 C15.1587681,8.61927863 15.2675176,8.72802815 15.3479983,8.85679729 Z",
    id: "Triangle",
    fill: "#FFFFFF",
    transform: "translate(14.500000, 13.500000) rotate(-270.000000) translate(-14.500000, -13.500000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.b974e96f.svg";
export { ForwardRef as ReactComponent };